// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-ZrD6l";
var _4 = "header-3R6U_";
var _5 = "buttons-2Bkep";
var _6 = "modal__paper-2sk6v";
var _7 = "skipVisaButton-2_mhK";
var _8 = "saveButton-1_6eB";
var _9 = "button-29Q8-";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "header", _5 as "buttons", _6 as "modal__paper", _7 as "skipVisaButton", _8 as "saveButton", _9 as "button" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "header": _4, "buttons": _5, "modal__paper": _6, "skipVisaButton": _7, "saveButton": _8, "button": _9 }
